import * as React from 'react';
import axios from 'axios';

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import PreloaderAnim from './PreloaderAnim'

import {destURL,createUserData} from './../utils/Utils'

import RegelsMedalsLady from './RegelsMedalsLady'

const gemeineKreten = [
  "Dikke prutsers, ga lekker thuis minigolf spelen! 🏌️‍♀️",
  "Dit is geen golf, dit is gewoon landschap vernieling! 💀",
  "Hebben jullie de bal wel eens gezien vandaag? 👀",
  "Zelfs een blinde mol slaat beter dan dit zooitje! 🦔",
  "Ga toch lekker een balletje trappen ofzo... 😩",
  "De greenkeeper heeft een klacht ingediend! 🚨",
  "Is dit golf of zoeken jullie paddenstoelen? 🍄",
  "Oma met haar rollator komt verder dan jullie! 👵",
  "De ballen zijn banger voor jullie dan andersom! 😱",
  "Tip: de hole zit NIET in het bos! 🌲",
  "Jullie handicap is niet hoog genoeg voor dit niveau! 📉",
  "Golf? Dit lijkt meer op een natuurwandeling met stokken! 🥾"
];

export default function LadiesComponent() {
  const [regels, setRegels] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [kreet] = React.useState(() => gemeineKreten[Math.floor(Math.random() * gemeineKreten.length)]);

  React.useEffect(() => {
//    let u = destURL + "?test=1"
    let u = destURL + "?"+window._currentYear+"=1"
    if(window.location.href.indexOf("dinsdaghakkers") > -1 )u = destURL + "?"+window._currentYear+"=1"
    axios.get(u)
      .then(res => {
        let uData = createUserData(res.data)
        console.log(uData)
        let arr = []
        let a = Object.keys(uData)
        for(let i=0;i<a.length;i++) {
          let u = uData[a[i]]
          let ladies = u.getLadies()
          let name = u.getName()
          arr.push({name:name,ladies:ladies})
        }
        // Sort by ladies (highest first = most shame), if equal sort by last name
        arr.sort((a,b) => {
          const ladiesA = a.ladies || 0
          const ladiesB = b.ladies || 0
          if (ladiesA === ladiesB || (ladiesA === 0 && ladiesB === 0)) {
            // Sort by last name (alphabetically)
            const lastNameA = a.name.split(' ').pop().toLowerCase()
            const lastNameB = b.name.split(' ').pop().toLowerCase()
            return lastNameA.localeCompare(lastNameB)
          }
          return ladiesB - ladiesA
        })
        setRegels(arr)
        setLoading(false)
      })
      .catch(err => {
        console.error('Fout bij ophalen data:', err)
        setError('Kon de data niet ophalen. Controleer je internetverbinding of probeer het later opnieuw.')
        setLoading(false)
      })
  },[]);

  return (
    <>
        <Toolbar />
        <h1 style={{margin:0}}>Ladies klassement</h1>
        {loading && <PreloaderAnim />}
        {error && (
          <div style={{padding: '20px', backgroundColor: '#ffebee', borderRadius: '8px', color: '#c62828', marginTop: '20px'}}>
            <strong>Fout:</strong> {error}
          </div>
        )}
        {!loading && !error && regels.map((item, i) => {
          return <RegelsMedalsLady key={i} index={i} medal={i+1} caption={item.name} count={item.ladies} />
         })}
         {!loading && !error && (
           <p style={{
             marginTop: '30px',
             padding: '15px',
             backgroundColor: 'rgba(255,255,255,0.7)',
             borderRadius: '12px',
             textAlign: 'center',
             fontStyle: 'italic',
             fontSize: '16px',
             color: '#c62828',
             animation: 'rowSlideIn 0.4s ease-out forwards',
             animationDelay: `${regels.length * 0.08 + 0.3}s`,
             opacity: 0
           }}>
             {kreet}
           </p>
         )}
         <Toolbar />
    </>
  );
}